export default function labelValue(label?: string, value?: string) {
    return (
      <>
        <div className='mb-4'>
          <div className='fw-bold'>{label ?? '—'}</div>
          <div className='text-muted'>{value ?? '—'}</div>
        </div>
      </>
    )
  }